import { render } from "./ProductGroupFilter.vue?vue&type=template&id=3c67e8b0&scoped=true&ts=true"
import script from "./ProductGroupFilter.vue?vue&type=script&lang=ts"
export * from "./ProductGroupFilter.vue?vue&type=script&lang=ts"

import "./ProductGroupFilter.vue?vue&type=style&index=0&id=3c67e8b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c67e8b0"]])

export default __exports__